import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, Switch, InputNumber } from 'antd';
import { XPagination, } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, } from '@/components/TableCell';
import { EditOutlined } from '@ant-design/icons';


class RateTable extends React.PureComponent {
    columns = () => [
        {
            title: '反馈类型',
            dataIndex: 'feedBackType',
            key: 'feedBackType',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '反馈渠道',
            dataIndex: 'systemTypeDesc',
            key: 'systemTypeDesc',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'operator',
            key: 'operator',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: '20%',
            onCell: tooltipStyle,
            render: (text, record) => (this.switchCell(text, record))
        },
        {
            title: '排序',
            dataIndex: 'sorting',
            key: 'sorting',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => this.sortCell(text, item)
        }
    ];


    // 解析表格数据
    _takeDataSource = (data) => {
        // 解析表格数据，使符合columns格式要求
        return data.map(item => {
            return item;
        });
    }

    //状态
    switchCell = (sw, item) => {
        let checked = true;
        if (sw == 0) {
            checked = false;
        }
        return (
            <Switch
                checkedChildren="开"
                unCheckedChildren="关"
                checked={checked}
                onChange={(value) => {
                    this.props.tableAction(item, 'switch', value);
                }}
            />
        );
    };

    // 表格项内容为可编辑
    sortCell = (value, item) => {
        const label = React.createRef();
        const box = React.createRef();
        const input = React.createRef();

        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <div className={styles.sort_box}>
                    <div className={styles.label} ref={label}>{value}</div>
                    <div className={styles.input} ref={box}>
                        <InputNumber
                            key={item.id}
                            style={{ width: '70px' }}
                            ref={input}
                            defaultValue={value}
                            min={1}
                            precision={0}
                            placeholder='请输入'
                            onBlur={(e) => {
                                box.current.style.display = 'none';
                                label.current.style.display = 'block';
                                if (e.target.value && (value != e.target.value)) {
                                    this.props.tableAction(item, 'sort', e.target.value);
                                }
                            }}
                        />
                    </div>
                    <div
                        className={styles.icon}
                        onClick={() => {
                            label.current.style.display = 'none';
                            box.current.style.display = 'block';
                            input.current.focus();
                        }}
                    >
                        <EditOutlined style={{ fontSize: '18px' }} />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { paginationChange } = this.props;
        const { dataList, pageSize, pageNum, resultTotal } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ x: 'max-content', y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

RateTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default RateTable;